import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { SubscriptionProvider } from "@/context/SubscriptionContext";
import { ConfirmProvider } from "@/context/ConfirmContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ComingSoon } from "@/components/ComingSoon";

import Landing from "@/pages/Landing";
import Waitlist from "@/pages/Waitlist";
import Admin from "@/pages/Admin";
import Login from "@/pages/auth/Login";
import Signup from "@/pages/auth/Signup";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import Onboarding from "@/pages/onboarding/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Opportunities from "@/pages/Opportunities";
import OpportunityDetail from "@/pages/OpportunityDetail";
import Ideas from "@/pages/Ideas";
import Content from "@/pages/Content";
import ContentEditor from "@/pages/ContentEditor";
import Intelligence from "@/pages/Intelligence";
import Connections from "@/pages/Connections";
import Profile from "@/pages/Profile";
import Settings from "@/pages/Settings";
import Analytics from "@/pages/Analytics";
import Library from "@/pages/Library";
import Production from "@/pages/Production";
import ProductionWorkspace from "@/pages/ProductionWorkspace";
import Pricing from "@/pages/Pricing";
import HookAnalysis from "@/pages/HookAnalysis";

import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import TermsOfService from "@/pages/legal/TermsOfService";
import CookiePolicy from "@/pages/legal/CookiePolicy";
import AcceptableUse from "@/pages/legal/AcceptableUse";

function Protected({ children }) {
  return <ProtectedRoute>{children}</ProtectedRoute>;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SubscriptionProvider>
          <ConfirmProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/waitlist" element={<Waitlist />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />

              {/* Public Legal Pages */}
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/cookies" element={<CookiePolicy />} />
              <Route path="/acceptable-use" element={<AcceptableUse />} />
              <Route path="/legal" element={<Navigate to="/privacy" replace />} />

              <Route path="/pricing" element={<Protected><Pricing /></Protected>} />
              <Route path="/hook-analysis" element={<Protected><HookAnalysis /></Protected>} />

              <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
              <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
              <Route path="/intelligence" element={<Protected><Intelligence /></Protected>} />
              <Route path="/opportunities" element={<Protected><Opportunities /></Protected>} />
              <Route path="/opportunities/:id" element={<Protected><OpportunityDetail /></Protected>} />
              <Route path="/ideas" element={<Protected><Ideas /></Protected>} />
              <Route path="/content" element={<Protected><Content /></Protected>} />
              <Route path="/content/:id" element={<Protected><ContentEditor /></Protected>} />
              <Route path="/connections" element={<Protected><Connections /></Protected>} />
              <Route path="/profile" element={<Protected><Profile /></Protected>} />
              <Route path="/settings" element={<Protected><Settings /></Protected>} />

              {/* Coming-soon modules (part of the connected workflow) */}
              <Route path="/production" element={<Protected><Production /></Protected>} />
              <Route path="/production/:id" element={<Protected><ProductionWorkspace /></Protected>} />
              <Route path="/library" element={<Protected><Library /></Protected>} />
              <Route path="/analytics" element={<Protected><Analytics /></Protected>} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </ConfirmProvider>
        </SubscriptionProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

